export const setupReducerKey = "setup";
export const setupInitialState = {
  categories: [],
  userTypes: [],
};
